import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ErrorNotFoundComponent } from "./page/not-found/not-found.component";
import { ErrorNotAuthorizedComponent } from "./page/not-authorized/not-authorized.component";
import { ErrorServerFailureComponent } from "./page/server-failure/server-failure.component";


const routes: Routes = [
  {
    path: "not-found",
    data: { title: "Page Not Found" },
    component: ErrorNotFoundComponent,
  },
  {
    path: "forbidden",
    data: { title: "Forbidden" },
    component: ErrorNotAuthorizedComponent,
  },
  {
    path: "server-error/:code",
    data: { title: "Server Error" },
    component: ErrorServerFailureComponent,
  },
  {
    path: "**",
    pathMatch: "full",
    data: { title: "404" },
    component: ErrorNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
